<template>
  <div>
    <div class="invoice-setting-header">
      <app-btn-submit :is-submitting="isUpdating" :css="'btn btn-primary btn-sm mr-2'" :text="$t('app.restoreSetting')"
        @on-click="restoreSetting()" />
      <app-btn-submit :is-submitting="isUpdating" :css="'btn btn-primary btn-sm ml-2'" :text="$t('app.update')"
        @on-click="save()" />
    </div>
    <div class="invoice-page-content form-group card-container-no-scroll">
      <div class="card">
        <h5 class="mb-4">Dấu phân cách</h5>
        <div class="grid grid-cols-2" style="gap: 18px">
          <div>
            <label>{{ $t("constant.INVOICE_SETTING.SEPRATOR_PHAN_NGAN") }}</label>
            <select class="custom-select form-control" name="Dấu phân cách phần nghìn"
              :value="valueTable.SEPRATOR_PHAN_NGAN"
              @change="e => onChangeSep(e, 'SEPRATOR_PHAN_NGAN', 'SEPRATOR_PHAN_THAP_PHAN')">
              <option value=",">Phẩy (,)</option>
              <option value=".">Chấm (.)</option>
            </select>
          </div>
          <div>
            <label>{{ $t("constant.INVOICE_SETTING.SEPRATOR_PHAN_THAP_PHAN") }}</label>
            <select class="custom-select form-control" name="Dấu phân cách phần thập phân"
              :value="valueTable.SEPRATOR_PHAN_THAP_PHAN"
              @change="e => onChangeSep(e, 'SEPRATOR_PHAN_THAP_PHAN', 'SEPRATOR_PHAN_NGAN')">
              <option value=",">Phẩy (,)</option>
              <option value=".">Chấm (.)</option>
            </select>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="mt-4 mb-4">
          <h5 class="mb-4">{{ $t("constant.INVOICE_SETTING.title.rateAndQuantityRounding") }}</h5>
          <div class="row text-center">
            <label class="col-3 align-self-center text-left">{{ $t("constant.INVOICE_SETTING.RATE")
              }}</label>
            <input class="col-1 form-control" type="number" min="0" max="8" v-model.number="valueTable.RATE"
              :class="{ 'is-invalid': invalidFields['RATE'] }" />
            <span class="col-2 align-self-center text-right p-0" style="font-size: 0.9rem">{{
              formatExample(valueTable.RATE)
              }}</span>
            <label class="col-2 align-self-center">{{ $t("constant.INVOICE_SETTING.QUANTITY") }}</label>
            <input class="col-1 form-control" type="number" min="0" max="8" v-model.number="valueTable.QUANTITY"
              :class="{ 'is-invalid': invalidFields['QUANTITY'] }" />
            <span class="col-3 align-self-center text-right" style="font-size: 0.9rem">{{
              formatExample(valueTable.QUANTITY) }}</span>
          </div>
        </div>
        <div class="context-menu__divider mb-2"></div>
        <div class="mt-4 mb-4">
          <h5 class="mb-4">{{ $t("constant.INVOICE_SETTING.title.priceValueRounding") }}</h5>
          <div class="row title" style="font-weight: bold; font-size: 0.9rem; white-space: nowrap;">
            <span class="col-3"></span>
            <span class="col-1" style="padding: 0">Tiền VND</span>
            <span class="col-4"></span>
            <span class="col-1" style="padding: 0">Tiền nguyên tệ</span>
            <span class="col-3"></span>
          </div>
          <div v-for="item in makeAroundInvoiceDetailSchema" class="row text-center mt-2 mb-2" :key="item.name">
            <label class="col-3 align-self-center text-left">{{ item.label }}</label>
            <input class="col-1 form-control" type="number" min="0" max="8" v-model.number="valueTable[item.domestic]"
              :class="{ 'is-invalid': invalidFields[item.domestic] }" />
            <span class="col-2 align-self-center text-right p-0" style="font-size: 0.9rem">{{
              formatExample(valueTable[item.domestic]) }}</span>
            <div class="col-2"></div>
            <input class="col-1 form-control" type="number" min="0" max="8" v-model.number="valueTable[item.foreign]"
              :class="{ 'is-invalid': invalidFields[item.foreign] }" />
            <span class="col-3 align-self-center text-right" style="font-size: 0.9rem">{{
              formatExample(valueTable[item.foreign]) }}</span>
          </div>
        </div>
        <div class="context-menu__divider mb-2"></div>
        <div class="mt-4 mb-4">
          <h5 class="mb-4">{{ $t("constant.INVOICE_SETTING.title.invoiceValueRounding") }}</h5>
          <div class="row title" style="font-weight: bold; font-size: 0.9rem; white-space: nowrap;">
            <span class="col-3"></span>
            <span class="col-1" style="padding: 0">Tiền VND</span>
            <span class="col-4"></span>
            <span class="col-1" style="padding: 0">Tiền nguyên tệ</span>
            <span class="col-3"></span>
          </div>
          <div v-for="item in onInvoiceSettingSchema" class="row text-center mt-2 mb-2" :key="item.name">
            <label class="col-3 align-self-center text-left">{{ item.label }}</label>
            <input class="col-1 form-control" type="number" min="0" max="8" v-model.number="valueTable[item.domestic]"
              :class="{ 'is-invalid': invalidFields[item.domestic] }" />
            <span class="col-2 align-self-center text-right p-0" style="font-size: 0.9rem">{{
              formatExample(valueTable[item.domestic]) }}</span>
            <div class="col-2"></div>
            <input class="col-1 form-control" type="number" min="0" max="8" v-model.number="valueTable[item.foreign]"
              :class="{ 'is-invalid': invalidFields[item.foreign] }" />
            <span class="col-3 align-self-center text-right" style="font-size: 0.9rem">{{
              formatExample(valueTable[item.foreign]) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import AppBasePage from '@/pages/base-page';
// import AppMainSidebar from '@/portal-components/main/sidebar';
// import AppForm from '@/components/app-form/';
import AppBtnSubmit from '@/components/app-button/index';
import EInvoiceProxy from '../../store/proxies/e-invoice/e-invoice-proxy';
import ToastUtils from '@/utils/toast';
import { mapActions } from 'vuex';

const ThisEInvoiceProxy = new EInvoiceProxy();

const DEFAULT_VALUE_TABLE = {
  SEPRATOR_PHAN_THAP_PHAN: ',',
  SEPRATOR_PHAN_NGAN: '.',
  RATE: 0,
  QUANTITY: 0,
  TAX_MONEY: 0,
  TAX_MONEY__FOREIGN: 0,
  SUB_TOTAL: 0,
  SUB_TOTAL__FOREIGN: 0,
  UNIT_PRICE: 0,
  UNIT_PRICE__FOREIGN: 0,
  TOTAL_MONEY: 0,
  TOTAL_MONEY__FOREIGN: 0,
  TAX_GTGT_MONEY_10: 0,
  TAX_GTGT_MONEY_10__FOREIGN: 0,
  TAX_GTGT_MONEY_5: 0,
  TAX_GTGT_MONEY_5__FOREIGN: 0,
  TAX_GTGT_MONEY: 0,
  TAX_GTGT_MONEY__FOREIGN: 0,
  CHIET_KHAU_MONEY: 0,
  CHIET_KHAU_MONEY__FOREIGN: 0,
  SUM_LOADS_MONEY: 0,
  SUM_LOADS_MONEY__FOREIGN: 0
};

/*
TODO:
add properties to initialValueTableProps object on page load
add Khoi phuc cai dat goc
*/

export default {
  name: 'InvoiceSetting',
  components: {
    AppBtnSubmit,
    // AppForm,
    // AppBasePage,
    // AppMainSidebar
  },
  // computed: {
  //     ...mapState(['appNavbarDisplay']),
  // },
  data() {
    return {
      valueTable: {
        ...DEFAULT_VALUE_TABLE
      },
      apiOriginalSetting: null,
      invalidFields: {},
      makeAroundQuantityAndRateSchema: [
        {
          name: 'RATE',
          label: this.$t('constant.INVOICE_SETTING.RATE')
        },
        {
          name: 'QUANTITY',
          label: this.$t('constant.INVOICE_SETTING.QUANTITY')
        }
      ],
      makeAroundInvoiceDetailSchema: [
        {
          name: 'TAX_MONEY',
          domestic: 'TAX_MONEY',
          foreign: 'TAX_MONEY__FOREIGN',
          label: this.$t('constant.INVOICE_SETTING.TAX_MONEY'),
        },
        {
          name: 'SUB_TOTAL',
          domestic: 'SUB_TOTAL',
          foreign: 'SUB_TOTAL__FOREIGN',
          label: this.$t('constant.INVOICE_SETTING.SUB_TOTAL'),
        },
        {
          name: 'UNIT_PRICE',
          domestic: 'UNIT_PRICE',
          foreign: 'UNIT_PRICE__FOREIGN',
          label: this.$t('constant.INVOICE_SETTING.UNIT_PRICE'),
        }
      ],
      onInvoiceSettingSchema: [
        {
          name: 'TOTAL_MONEY',
          domestic: 'TOTAL_MONEY',
          foreign: 'TOTAL_MONEY__FOREIGN',
          label: this.$t('constant.INVOICE_SETTING.TOTAL_MONEY'),
        },
        {
          name: 'TAX_GTGT_MONEY_10',
          domestic: 'TAX_GTGT_MONEY_10',
          foreign: 'TAX_GTGT_MONEY_10__FOREIGN',
          label: this.$t('constant.INVOICE_SETTING.TAX_GTGT_MONEY_10'),
        },
        {
          name: 'TAX_GTGT_MONEY_5',
          domestic: 'TAX_GTGT_MONEY_5',
          foreign: 'TAX_GTGT_MONEY_5__FOREIGN',
          label: this.$t('constant.INVOICE_SETTING.TAX_GTGT_MONEY_5'),
        },
        {
          name: 'TAX_GTGT_MONEY',
          domestic: 'TAX_GTGT_MONEY',
          foreign: 'TAX_GTGT_MONEY__FOREIGN',
          label: this.$t('constant.INVOICE_SETTING.TAX_GTGT_MONEY'),
        },
        {
          name: 'CHIET_KHAU_MONEY',
          domestic: 'CHIET_KHAU_MONEY',
          foreign: 'CHIET_KHAU_MONEY__FOREIGN',
          label: this.$t('constant.INVOICE_SETTING.CHIET_KHAU_MONEY'),
        },
        {
          name: 'SUM_LOADS_MONEY',
          domestic: 'SUM_LOADS_MONEY',
          foreign: 'SUM_LOADS_MONEY__FOREIGN',
          label: this.$t('constant.INVOICE_SETTING.SUM_LOADS_MONEY'),
        }
      ],
      isUpdating: false,
    };
  },
  created() {
    this.loadSellerSettings();
  },
  methods: {
    ...mapActions(['setState']),
    async loadSellerSettings() {
      const localData = localStorage.getItem('seller-setting-list');
      if (localData) {
        try {
          const parsed = JSON.parse(localData);
          if (parsed) this.valueTable = { ...this.valueTable, ...parsed };
        } catch (e) {
          console.warn('Không đọc được localStorage:', e);
        }
      }

      try {
        const response = await ThisEInvoiceProxy.getListSetting();

        const [SEPRATOR_PHAN_THAP_PHAN, SEPRATOR_PHAN_NGAN] = response.seprator__settings;
        const [RATE, QUANTITY] = response.qty_rate__settings;
        const on_detail_invoice__settings = response.on_detail_invoice__settings;
        const on_invoice__settings = response.on_invoice__settings;

        const onInvoiceSettings = on_detail_invoice__settings
          .concat(on_invoice__settings)
          .reduce(
            (acc, item) => ({
              ...acc,
              [item.key]: acc[item.key] || item.num_val,
            }),
            {}
          );

        this.valueTable = {
          SEPRATOR_PHAN_THAP_PHAN: SEPRATOR_PHAN_THAP_PHAN.text_val,
          SEPRATOR_PHAN_NGAN: SEPRATOR_PHAN_NGAN.text_val,
          QUANTITY: QUANTITY.num_val,
          RATE: RATE.num_val,
          ...onInvoiceSettings,
        };

        this.apiOriginalSetting = { ...this.valueTable };

        localStorage.setItem('seller-setting-list', JSON.stringify(this.valueTable));

        this.setState({ appLoading: false });
      } catch (error) {
        ToastUtils.showToast('error', error.message || error);
      }
    },
    onChangeSep(event, thisSeparator, otherSepToChange) {
      const value = event.target.value
      this.valueTable[thisSeparator] = value
      this.valueTable[otherSepToChange] = value === ',' ? '.' : ','
    },
    formatExample(rounding) {
      let baseString = `3${this.valueTable.SEPRATOR_PHAN_NGAN}000`
      if (rounding > 0) {
        baseString = baseString + this.valueTable.SEPRATOR_PHAN_THAP_PHAN + Array(rounding).fill('2').join('')
      }
      return baseString
    },
    save() {
      this.$modal.show('dialog', {
        title: `${this.$t('app.confirm')} ${this.$t('app.update').toLowerCase()}`,
        text: `${this.$t('app.changeInvoiceConfig')}`,
        okText: this.$t('app.confirm'),
        okClass: 'btn btn-primary btn-sm',
        showLoading: true,
        onOk: async () => {
          this.isUpdating = true
          this.invalidFields = {};

          const invalid = {};

          for (const [key, val] of Object.entries(this.valueTable)) {
            if (
              val === '' ||
              val === null ||
              val === undefined ||
              (typeof val === 'number' && isNaN(val))
            ) {
              invalid[key] = true;
            }
          }

          if (Object.keys(invalid).length > 0) {
            this.invalidFields = invalid;
            ToastUtils.showToast(
              'error',
              `${this.$t('app.enterCompleteData')} (${Object.keys(invalid).length} ${this.$t('app.boxEmpty')})`
            );
            this.isUpdating = false;
            return;
          }

          if (
            !this.valueTable.SEPRATOR_PHAN_THAP_PHAN ||
            !this.valueTable.SEPRATOR_PHAN_NGAN
          ) {
            ToastUtils.showToast('error', `${this.$t('app.choose2delimiters')}`);
            this.isUpdating = false;
            return;
          }

          ThisEInvoiceProxy.updateSetting(JSON.stringify(this.valueTable)).then((res) => {
            this.setState({
              sellerSettingList: res
            })
            localStorage.setItem('seller-setting-list', JSON.stringify(res));
            ToastUtils.showToast('success', this.$t('app.updateSuccess'));
            this.isUpdating = false
          }).catch((error) => {
            ToastUtils.showToast('error', error.message || error);
          })
        },
      });
    },
    restoreSetting() {
      this.$modal.show('dialog', {
        title: `${this.$t('app.confirm')} ${this.$t('app.restoreSetting').toLowerCase()}`,
        text: `${this.$t('app.restoreInvoiceConfig')}`,
        okText: this.$t('app.confirm'),
        okClass: 'btn btn-primary btn-sm',
        showLoading: true,
        onOk: async () => {
          this.valueTable = { ...DEFAULT_VALUE_TABLE };
          try {
            await ThisEInvoiceProxy.updateSetting(JSON.stringify(this.valueTable));

            await this.loadSellerSettings();

            ToastUtils.showToast('success', `${this.$t('app.restoreInvoiceConfigSuccess')}`);
          } catch (e) {
            ToastUtils.showToast('error', e.message || e);
          }
        }
      });
    }
  },
};
</script>
<style lang="scss">
.invoice-page-content {
  label {
    display: inline-block;
    margin-bottom: 0
  }

  h5 {
    color: #0078D4;
    font-size: 16px;
    font-weight: bold;
  }

  display: flex;
  flex-direction: column;

}

.invoice-setting-header {
  position: sticky;
  top: 0;
  display: flex;
  z-index: 10;
  justify-content: flex-end;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  background-color: white;
}

.is-invalid {
  border: 1px solid #e3342f !important;
  box-shadow: 0 0 4px rgba(227, 52, 47, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/portal-components/setting/invoice-setting.vue